import { AnalysisItem, LegendItem, LocationItem } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import gap from "report/common/gap";
import tableColumn from "report/common/table-column";
import getTitle from "report/common/title";
import getTpye from "report/common/type";
import groupLabel from "./group-label";
import { sortData } from "../../common/sort-group-table";

const get = async (
  t: any,
  locationItems: LocationItem[],
  eventResult: AnalysisItem[],
  eventLegend: LegendItem[],
  count: number,
  aggregationUnits: string[],
  unit: string,
  currency: string,
): Promise<Content[]> => {
  const group = groupLabel(
    eventResult,
    eventLegend[0],
    locationItems,
    aggregationUnits
  );
  // const groupedData = groupData(eventResult, eventLegend[0]);
  const sortedData = sortData(group, eventLegend[0]);

  return [
    getTpye(t("report.Events"), 802),
    gap(30),
    getTitle(t("report.analysis")),
    tableColumn(
      t,
      sortedData,
      aggregationUnits, //eventResult.length,
      t("legend." + eventLegend[0].subtitle),
      // undefined,
      unit,
      currency
    )
  ];
};

export default get;
